export const setTemplateId = (templateId) => {
   return {
      type: "SET_TEMPLATE_ID",
      templateId
   };
};

export const setTemplateName = (templateName) => {
   return {
      type: "SET_TEMPLATE_NAME",
      templateName
   };
};

export const setTemplateCoverPhotoURL = (coverPhotoURL) => {
   return {
      type: "SET_TEMPLATE_COVER",
      coverPhotoURL
   };
};

export const setTemplateSubject = (templateSubject) => {
   return {
      type: "SET_TEMPLATE_SUBJECT",
      templateSubject
   };
};

export const setTemplateContent = (templateContent) => {
   return {
      type: "SET_TEMPLATE_CONTENT",
      templateContent
   };
};

export const setTemplateSubscribers = (templateSubscribers) => {
   return {
      type: "SET_TEMPLATE_SUBSCRIBERS",
      templateSubscribers
   };
};
export const setTemplateIsNew = (templateIsNew) => {
   return {
      type: "SET_TEMPLATE_IS_NEW",
      templateIsNew
   };
};

export const setTemplateSaveable = (templateSaveable) => {
   return {
      type: "SET_TEMPLATE_SAVEABLE",
      templateSaveable
   };
};

export const setTemplateNewsletter = (templateNewsletter) => {
   return {
      type: "SET_TEMPLATE_NEWSLETTER",
      templateNewsletter
   };
};
export const setNewsletterCsv = (csv) => {
   return {
      type: "SET_NEWSLETTER_CSV",
      csv
   };
};

export const setNewsletterContent = (newsletterContent) => {
   return {
      type: "SET_NEWSLETTER_CONTENT",
      newsletterContent
   };
};

export const setIsFileAdded = (isFileAdded) => {
   return {
      type: "SET_IS_FILE_ADDED",
      isFileAdded
   };
};
